/**
 * Инициалы из названия ЮЛ или ФИО. Правило целиком описано в
 * docs/ui-kit/contracts/avatar.md, раздел «Инициалы».
 *
 * Живёт внутри слайса и наружу не экспортируется: одно и то же ЮЛ обязано получать одни и те же
 * буквы на всех экранах, а это возможно только пока правило одно.
 */

/**
 * Правовые формы, которые в инициалы не попадают. Сравнение идёт по целому токену в верхнем
 * регистре, поэтому «Аокс» или «Ипотека» не пострадают.
 */
const LEGAL_FORMS = new Set([
  'ООО',
  'ОАО',
  'ЗАО',
  'ПАО',
  'АО',
  'НАО',
  'ОДО',
  'ИП',
  'ГУП',
  'МУП',
  'ФГУП',
  'АНО',
  'НКО',
  'ТСЖ',
  'ПК',
  'КФХ',
  'ТОО',
  'ЧП',
  'LLC',
  'LTD',
  'INC',
  'CORP',
  'CO',
  'GMBH',
  'PLC',
  'SA',
  'AG',
  'BV',
])

/** Разделитель — всё, что не буква и не цифра: кавычки всех видов, скобки, точки, дефисы. */
const SEPARATORS = /[^\p{L}\p{N}]+/u

export function getInitials(name: string): string {
  const tokens = name.split(SEPARATORS).filter(Boolean)

  if (tokens.length === 0) {
    return ''
  }

  // Осталась только правовая форма («ООО») — показываем её: это честнее пустого круга
  const meaningful = tokens.filter((token) => !LEGAL_FORMS.has(token.toUpperCase()))
  const [first, second] = meaningful.length > 0 ? meaningful : tokens

  if (first === undefined) {
    return ''
  }

  // Два слова и больше — по первой букве от каждого из первых двух; одно слово — две его буквы
  const initials = second === undefined ? first.slice(0, 2) : first.charAt(0) + second.charAt(0)

  return initials.toUpperCase()
}
